import { idyuJsonRpc } from "@/assets/js/idyu/connect.js";
/* eslint-disable no-console */
class RtcConnection {
  constructor(messager, profile, to, track) {
    let thisObj = this;
    this.onTrack = track;
    this.messager = messager;
    this.profile = profile;
    this.rtcPartner = to;
    const stunServers = ["stun:stun.l.google.com:19302"];
    this.rtc = new RTCPeerConnection({
      iceServers: [{ urls: stunServers }]
    });

    this.rtc.ontrack = function(event) {
      console.log("Track received");
      if (thisObj.onTrack != undefined) {
        thisObj.onTrack(event.track);
      }
    };

    this.rtc.onicecandidate = function(event) {
      if (!thisObj.rtcPartner) {
        return;
      }

      if (!event.candidate) {
        return;
      }

      console.log("Candidate received");
      thisObj.sendJson({
        action: "rtc",
        channel: "/notifications/" + thisObj.rtcPartner.pseudo,
        data: {
          category: "rtc",
          type: "candidate",
          idFrom: thisObj.profile.id,
          idTo: thisObj.rtcPartner.id,
          payload: event.candidate
        }
      });
    };

    this.rtc.onnegotiationneeded = async function() {
      let offer = await thisObj.rtc.createOffer();
      thisObj.rtc.setLocalDescription(offer);
      const messageObj = {
        action: "rtc",
        channel: "/notifications/" + thisObj.rtcPartner.pseudo,
        data: {
          category: "rtc",
          type: "offer",
          idTo: thisObj.rtcPartner.id,
          idFrom: thisObj.profile.id,
          payload: offer
        }
      };

      thisObj.sendJson(messageObj);
      console.log("Offer Sent");
    };
  }

  async onOffer(from, msg) {
    console.log("Offer received");

    // this.rtcListener("init");
    this.rtc.setRemoteDescription(new RTCSessionDescription(msg.data.payload));
    let answer = await this.rtc.createAnswer();
    await this.rtc.setLocalDescription(answer);
    this.rtcPartner = from;
    this.sendJson({
      action: "rtc",
      channel: "/notifications/" + from.pseudo,
      data: {
        category: "rtc",
        type: "answer",
        idTo: from.id,
        idFrom: this.profile.id,
        payload: answer
      }
    });
  }

  async onAnswer(answer) {
    console.log("Answer received");
    await this.rtc.setRemoteDescription(new RTCSessionDescription(answer));
  }

  onCandidate(candidate) {
    console.log("Peer candidate received");
    this.rtc.addIceCandidate(new RTCIceCandidate(candidate));
  }

  async shareScreen() {
    let stream = await navigator.mediaDevices.getDisplayMedia();
    this.rtc.addTransceiver(stream.getVideoTracks()[0]);
  }

  sendJson(msg) {
    this.messager.sendJson(msg);
  }

  close() {
    this.rtc.close();
  }
}

export class RtcManager {
  constructor(messager, profile) {
    this.profile = profile;
    this.messager = messager;
    this.connections = {};
  }

  messageReceived(msg) {
    switch (msg.data.type) {
      case "offer":
        this.onOffer(msg);
        break;
      case "answer":
        this.onAnswer(msg);
        break;
      case "candidate":
        this.onCandidate(msg);
        break;
      default:
        break;
    }
  }

  async onOffer(msg) {
    let from = await idyuJsonRpc("getProfileSummary", msg.data.idFrom);
    if (!this.connections[msg.data.idFrom]) {
      this.connections[msg.data.idFrom] = new RtcConnection(this.messager, this.profile, from, this.onTrack);
    }
    this.connections[msg.data.idFrom].onOffer(from, msg);
  }

  onAnswer(msg) {
    if (this.connections[msg.data.idFrom]) this.connections[msg.data.idFrom].onAnswer(msg.data.payload);
  }

  onCandidate(msg) {
    if (this.connections[msg.data.idFrom]) this.connections[msg.data.idFrom].onCandidate(msg.data.payload);
  }

  async shareScreen(to) {
    if (!this.connections[to.id]) {
      this.connections[to.id] = new RtcConnection(this.messager, this.profile, to, this.onTrack);
    }
    this.connections[to.id].shareScreen();
  }
}
